import React  from 'react';
// import logo from './logo.svg';
import './App.css';
import WebRoutes from './routes/WebRoutes';
import ToastMessage from './components/ToastMessage';
import { createTheme, ThemeProvider } from '@mui/material/styles';





const theme = createTheme({
  palette: {
    primary: {
      main: '#8BAF91',
      contrastText: '#fff',
      // light: will be calculated from palette.primary.main,
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      main: '#DDABAB',
    },
  },
});


function App() {
  return <>
  <ThemeProvider theme={theme}>
    <WebRoutes />
    <ToastMessage />
    </ThemeProvider>
  </>;
  
}

export default App;
